<script>
import FloatingFrame from "../components/floatingFrame";
import axios from "axios";
import Cookies from "js-cookie";
import { login_url, changePassword } from "@/api/url";
export default {
  name: "user",
  components: {
    FloatingFrame
  },
  data() {
    return {
      username: "",
      passwordFormVisible: false, //修改密码表单
      showDropDownList: false, //下拉列表
      showFloatingBg: false, //弹出框背景
      isClickFloatingClose: false, //点击弹出框背景是否隐藏弹出层
      formData: {
        oldPassword: "",
        newPassword: "",
        checkPassword: ""
      }
    };
  },

  methods: {
    showList() {
      this.showFloatingBg = true;
      this.showDropDownList = true;
      this.isClickFloatingClose = true;
    },
    hiddenList() {
      this.showFloatingBg = false;
      this.showDropDownList = false;
    },
    hiddenFloatingBg() {
      if (this.isClickFloatingClose) {
        this.showFloatingBg = false;
        this.showDropDownList = false;
      } else {
        this.showFloatingBg = true;
      }
    },
    editPassword() {
      this.hiddenList();
      this.showFloatingBg = true;
      this.passwordFormVisible = true;
      this.isClickFloatingClose = false;
    },
    editPasswordTrue() {
      const { oldPassword, newPassword, checkPassword } = this.formData;
      if (!oldPassword || !newPassword || !checkPassword) {
        alert("旧密码，新密码，确认密码不能为空");
        return;
      }
      if (newPassword !== checkPassword) {
        alert("新密码和确认密码不一致");
        return;
      }
      this.passwordFormVisible = false;
      this.showFloatingBg = false;
      this.$postRequest(
      changePassword() + 
          "?oldPass=" +
          encodeURIComponent(oldPassword) +
          "&newPass=" +
          encodeURIComponent(newPassword),
        {}
      ).then(data => {
        if (!data.data) {
          this.$notify.error({
            title: "失败",
            message: "旧密码输入错误！"
          });
        } else {
          this.$notify({
            title: "成功",
            message: "密码修改成功！",
            type: "success"
          });
        }
      });
      this.formData = {
        oldPassword: "",
        newPassword: "",
        checkPassword: ""
      };
    },
    canclePassword() {
      this.passwordFormVisible = false;
      this.showFloatingBg = false;
    },
    getInfo(e, info) {
     
      if (info === "旧密码") {
        this.formData.oldPassword = e.target.value;
      }
      if (info === "新密码") {
        this.formData.newPassword = e.target.value;
      }
      if (info === "确认密码") {
        this.formData.checkPassword = e.target.value;
      }
    },
    //暂未使用
    vali(e, info) {
      const value = e.target.value;
      if (!value) {
      }
    },
    logout() {
      var _this = this;
      axios({
        method: "delete",
        url: login_url() + "?access_token=" + Cookies.get("Authorization"),
        headers: { Authorization: "Basic dnVlOnZ1ZQ==" }
      })
        .then(function(response) {
          var data = response.data;
          if (data.status == 200) {
            Cookies.remove("Authorization", { path: "" });
            if (Cookies.get("checkedOutside") != 1) {
              Cookies.remove("usernameOutside");
            }
            _this.$router.push("/");
          }
        })
        .catch(function(error) {});
    }
  },

  render() {
    const { username, passwordFormVisible, showDropDownList, formData } = this;
    const {
      logout,
      showList,
      hiddenList,
      hiddenFloatingBg,
      editPassword,
      canclePassword,
      editPasswordTrue,
      getInfo
    } = this;
    const passwordForm = () => {
      return passwordFormVisible ? (
        <div class="password-form">
          <form>
            <div class="edit-password-item">
              <label>
                <span class="edit-password-item-tip">*</span>旧密码:
              </label>
              <input
                type="text"
                onInput={e => {
                  getInfo(e, "旧密码");
                }}
              ></input>
            </div>
            <div class="edit-password-item">
              <label>
                <span class="edit-password-item-tip">*</span>新密码:
              </label>
              <input
                type="text"
                onInput={e => {
                  getInfo(e, "新密码");
                }}
              ></input>
            </div>
            <div class="edit-password-item">
              <label>
                <span class="edit-password-item-tip">*</span>确认密码:
              </label>
              <input
                type="text"
                onInput={e => {
                  getInfo(e, "确认密码");
                }}
              ></input>
            </div>
          </form>
          <div class="dialog-footer">
            <el-button type="primary" onClick={editPasswordTrue}>
              确 定
            </el-button>
            <el-button onClick={canclePassword}>取 消</el-button>
          </div>
        </div>
      ) : (
        <div />
      );
    };
    return (
      <div class="userInfo">
        <div onClick={showList}>
          <img src={require("@/assets/images/menu_img/user.png")} />
          <span>{username}</span>
        </div>
        <ul
          class="userInfo-dropdown-list userInfo-dropdown-list-hidden"
          style={{ display: showDropDownList ? "block" : "none" }}
        >
          <li onClick={editPassword}>修改密码</li>
          <li onClick={logout}>退出</li>
        </ul>
        <FloatingFrame
          showFloatingBg={this.showFloatingBg}
          on-func={hiddenFloatingBg}
        ></FloatingFrame>
        {passwordForm()}
      </div>
    );
  },
  mounted() {
    this.username = Cookies.get("userName");
  }
};
</script>
<style lang='scss'>
.userInfo {
  margin-left: -5px;
  margin-right: 20px;
  cursor: pointer;
  position: relative;

  .el-button--default span {
    color: #606266 !important;
  }
}
.userInfo-dropdown-list {
  position: absolute;
  // top: 60px;
  // right:70px;
  width: 150px;
  height: 100px;
  background: white;
  box-shadow: 0 0 10px 1px #333;
  border-radius: 4px;
  z-index: 25000 !important;
  padding: 0 10px;
  box-sizing: border-box;
  li {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ccc;
  }
}
.userInfo-dropdown-list-hidden {
  display: none;
}
.password-form {
  width: 400px;
  height: 400px;
  position: fixed;
  z-index: 30000;
  box-sizing: border-box;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -200px;
  padding: 0 30px;
  box-shadow: 0 0 10px 1px black;
  border-radius: 10px;
  background: white;
  animation: myfirst 0.8s;
  -moz-animation: myfirst 0.8s; /* Firefox */
  -webkit-animation: myfirst 0.8s; /* Safari 和 Chrome */
  -o-animation: myfirst 0.8s; /* Opera */
}
.userInfo .dialog-footer {
  display: flex;
  justify-content: center;
}
.edit-password-item {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  input {
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 40px;
    width: 78%;
    box-sizing: border-box;
    padding-left: 20px;
    margin-left: 1%;
  }
  label {
    text-align: right;
    width: 20%;
  }
  .edit-password-item-tip {
    color: red !important;
  }
}
@keyframes myfirst {
  from {
    top: 0;
    right: 0;
    margin-left: 0;
    margin-top: 0;
  }
  to {
    top: 50%;
    left: 50%;
    margin-left: -150px;
    margin-top: -200px;
  }
}
</style>
